<template>
  <div>
    <!-- profile -->
    <div class="card mb-g rounded-top">
      <div class="row no-gutters row-grid">
        <div class="col-12">
          <div class="d-flex flex-column align-items-center justify-content-center p-4">
            <h2 class="mb-0 fw-700 text-center mt-1">{{ profile.firstName }} {{ profile.lastName }}</h2>
          </div>
        </div>

        <detail-item class="col-md-12" label="Adres e-mail">
          {{ profile.email || 'Brak' }}
        </detail-item>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import DetailItem from '@/components/details/DetailItem';

// @vuese
// Szczegóły profilu
// @group Profile
export default {
  components: {
    DetailItem
  },
  computed: mapState({
    profile: state => state.profile.data
  })
};
</script>
